export const mapStateToPlaceOrderDetails = (state) => {
  const entities = state.entities;
  const billingAddress = entities.Addresses.filter(a => a.Id === entities.SelectedBillingAddressId)[0];
  return {
    SelectedShippingAddress: billingAddress, // BBS DDD 2018-01-18 Just duplicate billing address, as nothing is shippable
    SelectedBillingAddress: billingAddress,
    SelectedShippingOption: null,
    SelectedPayment: {
      Id: entities.SelectedPaymentOptionId,
      BraintreePaymentNonce: entities.PaymentRecord.BraintreePaymentNonce,
      DeviceData: entities.PaymentRecord.DeviceData
    },
    BillingEqualsShipping: state.ui.useShippingForBilling
  };
}



// WEBPACK FOOTER //
// ./src/Components/checkout/components/mapStateToPlaceOrderDetails.js